import { render } from "./ChargebeeUpsellMarketingDomainsItem.vue?vue&type=template&id=b24e68f8&scoped=true"
import script from "./ChargebeeUpsellMarketingDomainsItem.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellMarketingDomainsItem.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellMarketingDomainsItem.vue?vue&type=style&index=0&id=b24e68f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b24e68f8"]])

export default __exports__